import { c } from 'react-compiler-runtime';
import { isElement } from 'react-is';
import classes from './SegmentedControl.module.css.js';
import { clsx } from 'clsx';
import { jsx, jsxs } from 'react/jsx-runtime';
import CounterLabel from '../CounterLabel/CounterLabel.js';

const SegmentedControlButton = t0 => {
  var _leadingVisual;
  const $ = c(31);
  let children;
  let className;
  let count;
  let leadingIcon;
  let leadingVisual;
  let rest;
  let selected;
  if ($[0] !== t0) {
    const {
      children: t1,
      leadingVisual: t2,
      leadingIcon: t3,
      selected: t4,
      className: t5,
      defaultSelected: _defaultSelected,
      count: t6,
      ...t7
    } = t0;
    children = t1;
    leadingVisual = t2;
    leadingIcon = t3;
    selected = t4;
    className = t5;
    count = t6;
    rest = t7;
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = count;
    $[4] = leadingIcon;
    $[5] = leadingVisual;
    $[6] = rest;
    $[7] = selected;
  } else {
    children = $[1];
    className = $[2];
    count = $[3];
    leadingIcon = $[4];
    leadingVisual = $[5];
    rest = $[6];
    selected = $[7];
  }
  const LeadingVisual = (_leadingVisual = leadingVisual) !== null && _leadingVisual !== void 0 ? _leadingVisual : leadingIcon;
  let t1;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = clsx(classes.Item);
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  const t2 = selected ? "" : undefined;
  let t3;
  if ($[9] !== className) {
    t3 = clsx(classes.Button, className);
    $[9] = className;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = clsx(classes.Content, "segmentedControl-content");
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== LeadingVisual) {
    t5 = LeadingVisual && /*#__PURE__*/jsx("div", {
      className: classes.LeadingIcon,
      children: isElement(LeadingVisual) ? LeadingVisual : /*#__PURE__*/jsx(LeadingVisual, {})
    });
    $[12] = LeadingVisual;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = clsx(classes.Text, "segmentedControl-text");
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== children) {
    t7 = /*#__PURE__*/jsx("div", {
      className: t6,
      "data-text": children,
      children: children
    });
    $[15] = children;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== count) {
    t8 = count !== undefined && /*#__PURE__*/jsx("span", {
      className: classes.Counter,
      children: /*#__PURE__*/jsx(CounterLabel, {
        children: count
      })
    });
    $[17] = count;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t5 || $[20] !== t7 || $[21] !== t8) {
    t9 = /*#__PURE__*/jsxs("span", {
      className: t4,
      children: [t5, t7, t8]
    });
    $[19] = t5;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== rest || $[24] !== selected || $[25] !== t3 || $[26] !== t9) {
    t10 = /*#__PURE__*/jsx("button", {
      "aria-current": selected,
      className: t3,
      type: "button",
      ...rest,
      children: t9
    });
    $[23] = rest;
    $[24] = selected;
    $[25] = t3;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== t10 || $[29] !== t2) {
    t11 = /*#__PURE__*/jsx("li", {
      className: t1,
      "data-selected": t2,
      children: t10
    });
    $[28] = t10;
    $[29] = t2;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  return t11;
};
SegmentedControlButton.__SLOT__ = Symbol('SegmentedControl.Button');

export { SegmentedControlButton as default };
